import { WalletActionCreators } from 'actions/wallet';
import { initTransactionList, initTransactionListFilter } from 'helper/wallet';
import { WalletHistoryState, WalletTransaction } from 'models/wallet';

export const initialState: WalletHistoryState = {
  data: initTransactionList(),
  filter: initTransactionListFilter(),
  isLoading: false
};

type Action = typeof WalletActionCreators[keyof typeof WalletActionCreators];

export function walletHistoryReducer(state = initialState, action: Action): typeof initialState {
  switch (action.type) {
    case WalletActionCreators.appendHistory.type: {
      const newContent: WalletTransaction[] = [];
      state.data.content.forEach((transaction: WalletTransaction) => {
        newContent.push(transaction);
      });
      action.payload.content.forEach((transaction: WalletTransaction) => {
        if (!newContent.some((t) => t.id === transaction.id)) {
          newContent.push(transaction);
        }
      });
      return { ...state, data: { ...action.payload, content: newContent } };
    }
    case WalletActionCreators.clearHistory.type:
      return { ...state, data: initTransactionList(), filter: initTransactionListFilter() };
    case WalletActionCreators.setHistoryIsOnRequest.type:
      return { ...state, isLoading: true };
    case WalletActionCreators.setHistoryIsReceived.type:
      return { ...state, isLoading: false };
    case WalletActionCreators.updateTransactionListFilter.type:
      return { ...state, filter: action.payload };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/reducers/wallet/history.ts